(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_sl-app-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
        function determinePlatform() {
            if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
                return "ios";
            } else if (/Android/i.test(window.navigator.userAgent)) {
                return "android";
            }
            return "other";
        };

        function getDownloadLink(platform) {
            if (platform === "ios") {
                return 'https://apps.apple.com/us/app/sleeplay/id6745164103';
            } else if (platform === "android") {
                return 'https://play.google.com/store/apps/details?id=co.shopney.sleeplay';
            }
            return 'https://apps.apple.com/us/app/sleeplay/id6745164103';
        };

		let app_download_btn = document.querySelectorAll(".app_download_btn");
		if (app_download_btn.length > 0) {
			let devicePlatformtype = determinePlatform();
			let downloadlink = getDownloadLink(devicePlatformtype);
			app_download_btn.forEach(function (e, i) {
				e.href = downloadlink;
			})
		}
	})
  } catch(e) { console.error(e); }
})();

})();
